$(document).ready(function () {
    if (window.location.hash.startsWith('#tab-')) {
        var tabEl = document.querySelector(window.location.hash.replace('tab-', '') + '-tab');
        var tab = new bootstrap.Tab(tabEl);
        tab.show();
    }
});
